import { useQuery } from "@tanstack/react-query";
import { QueryKeysEnum } from "../types/QueryKeysEnum";
import { useAccountClient } from "./useAccountClient";
import { getLanguagesList } from "../generated-api/account";

export const useLanguageList = (
  throwOnError?: boolean | ((error: Error) => boolean),
) => {
  const client = useAccountClient();
  const response = useQuery({
    queryKey: [QueryKeysEnum.InstallationList],
    queryFn: async () => {
      const { data } = await getLanguagesList({
        client,
        throwOnError: true,
      });

      return data;
    },
    throwOnError,
  });

  return response;
};
